import React from 'react';
import {Button} from '@goproblems/ui';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faFlag as faFlagRegular} from '@fortawesome/free-regular-svg-icons';
import {isMobile} from 'react-device-detect';
import {t} from 'i18next';
import {MODAL_PROBLEM_FLAGS, showModal} from '@utils';
import {SingleProblem} from '@types';

export const FlagButton = ({problem}: {problem: SingleProblem}) => {
    if (isMobile)
        return (
            <FontAwesomeIcon
                className="text-neutral-500 cursor-pointer mr-2"
                onClick={() => showModal(MODAL_PROBLEM_FLAGS)}
                fontSize={20}
                icon={faFlagRegular}
            />
        );
    return (
        <Button
            onClick={() => showModal(MODAL_PROBLEM_FLAGS)}
            variant="secondary"
            size="sm">
            {t('single_problem.add_view_flags')}
            {problem.flagStats.positiveFlagSum > 0 && (
                <span className="ml-1">
                    +{problem.flagStats.positiveFlagSum}
                </span>
            )}
            {problem.flagStats.negativeFlagSum < 0 && (
                <span className="ml-1">
                    {problem.flagStats.negativeFlagSum}
                </span>
            )}
        </Button>
    );
};
